import { render, staticRenderFns } from "./SelfCheck.vue?vue&type=template&id=65c08e0d&scoped=true&"
import script from "./SelfCheck.vue?vue&type=script&lang=ts&"
export * from "./SelfCheck.vue?vue&type=script&lang=ts&"
import style0 from "./SelfCheck.vue?vue&type=style&index=0&id=65c08e0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c08e0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/iwata/Documents/Project/SMILE-AYA/dev/smileaya-admin-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VTextarea})
